<template>
    <div class="submit-spc-order">
        <el-form ref="form" label-width="100px" label-position="left">
            <div class="form-title mt10">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                客户信息
            </div>
            <div class="info">
                <div class="info-list">
                    <div class="info-item">
                        <div class="label">合同类型：</div>
                        <div class="content">{{ Orders_Type == 0 ? '销售订单' : Customer_info.Orders_Type == 1 ? '服务订单' : '' }}</div>
                    </div>
                    <div class="flex">
                        <div class="info-item" v-if="PipelineCustomer.ID">
                            <div class="label">商机编号：</div>
                            <div class="content">{{ PipelineCustomer.ID + ' [' + PipelineCustomer.opportunityName + ']' }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item" v-if="Customer_info.Customer_Type != '1'">
                            <div class="label">客户编号：</div>
                            <div class="content label-middle">{{ Customer_info.Customer_Code }}</div>
                        </div>
                        <div class="info-item">
                            <div class="label">客户名称：</div>
                            <div class="content">{{ Customer_info.Customer_Name }}</div>
                        </div>
                        <div class="info-item" v-if="Customer_info.Customer_Type == '1'">
                            <div class="label">客户手机：</div>
                            <div class="content">{{ Customer_info.Person_Mobile }}</div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="info-item">
                            <div class="label">客户类型：</div>
                            <div class="content label-middle">{{ Customer_info.Customer_Type == '1' ? '个人客户' : '企业客户' }}</div>
                        </div>
                        <div class="info-item" v-if="Customer_info.Customer_Type == 0">
                            <div class="label">注册所在地：</div>
                            <div class="content">{{ Customer_info.Customer_RegAddr }}</div>
                        </div>
                    </div>
                    <div class="info-item">
                        <div class="label">付款方式：</div>
                        <div class="content">{{ submitpaymentObj.value }}</div>
                    </div>
                </div>
            </div>
            <div class="form-title">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                工程信息
            </div>
            <el-form-item label="工程区域">
                <el-select v-model="params.Customer_Project_Country" placeholder="请选择国家" class="el-select-medium" @change="countryChange" clearable filterable>
                    <el-option v-for="item in countryList" :key="item.Country_Code" :label="item.Country_CN" :value="item.Country_Code"></el-option>
                </el-select>
                <el-select class="el-select-medium ml10" v-model="params.Customer_Project_State" placeholder="省/直辖市" @change="provinceChange" clearable filterable>
                    <el-option v-for="item in provinceList" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                </el-select>
                <el-select class="el-select-medium ml10" v-model="params.Customer_Project_City" placeholder="市" @change="cityChange" clearable filterable>
                    <el-option v-for="item in cityListopt" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                </el-select>
                <el-select class="el-select-medium ml10" v-model="params.Customer_Project_County" placeholder="区/县" clearable filterable>
                    <el-option v-for="item in districtListopt" :key="item.Code" :label="item.Name" :value="item.Code"></el-option>
                </el-select>

                <font style="color: #ff0000; margin-left: 5px" v-if="SPCApply_BillType == 1">*</font>
            </el-form-item>
            <el-form-item label="工程名称">
                <el-input class="el-select-medium" v-model="params.Customer_Project_Name" maxlength="40" placeholder="工程名称，必填"></el-input>
                <el-select class="el-select-medium ml10" v-model="params.Orders_ProjectType_ID" placeholder="请选择行业分类" @change="getProjectTypes({ name: 'two', id: params.Orders_ProjectType_ID })">
                    <el-option v-for="item in ProjectTypesList" :key="item.Project_Type_ID" :label="item.Project_Type_Name" :value="item.Project_Type_ID">
                        <span style="float: left">{{ item.Project_Type_Name }}</span>
                    </el-option>
                </el-select>
                <el-select class="el-select-medium ml10" v-if="ProjectTypesListTwo.length" v-model="params.Orders_ProjectType_ID_Two" placeholder="请选择行业分类" @change="getProjectTypes({ name: 'three', id: params.Orders_ProjectType_ID_Two })">
                    <el-option v-for="item in ProjectTypesListTwo" :key="item.Project_Type_ID" :label="item.Project_Type_Name" :value="item.Project_Type_ID">
                        <span style="float: left">{{ item.Project_Type_Name }}</span>
                    </el-option>
                </el-select>
                <el-select class="el-select-medium ml10" v-if="ProjectTypesListThree.length" v-model="params.Orders_ProjectType_ID_Three" placeholder="请选择行业分类">
                    <el-option v-for="item in ProjectTypesListThree" :key="item.Project_Type_ID" :label="item.Project_Type_Name" :value="item.Project_Type_ID">
                        <span style="float: left">{{ item.Project_Type_Name }}</span>
                    </el-option>
                </el-select>
                <font style="color: #ff0000; margin-left: 5px" v-if="SPCApply_BillType == 1">*</font>
            </el-form-item>
            <el-form-item label="预计供货时间">
                <el-date-picker class="el-select-medium" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="params.SPCApply_PlanDeliveryDays"></el-date-picker>
                <font style="color: #ff0000; margin-left: 5px" v-if="SPCApply_BillType == 1">*</font>
            </el-form-item>
            <el-form-item label="办事处">
                <el-input class="el-select-medium" v-model="params.officeInfoDetail" readonly></el-input>
                <font style="color: #ff0000; margin-left: 5px" v-if="SPCApply_BillType == 1">*</font>
            </el-form-item>
            <el-form-item label="业务员">
                <el-select class="el-select-medium" v-model="params.Orders_OfficeManID" @change="publicSelectChange('office', $event)">
                    <el-option v-for="item in offinceList" :key="item.ID" :label="item.OwnerName" :value="item.ID"></el-option>
                </el-select>
                <font style="color: #ff0000; margin-left: 5px" v-if="SPCApply_BillType == 1">*</font>
            </el-form-item>
            <div class="form-title">
                <svg-icon icon-class="lm" class-name="lm-icon" />
                商品清单
            </div>
            <div class="cart-list-container">
                <div class="cart-list" v-for="items in cartList" :key="items.ID">
                    <div class="cart-top flex">
                        <div class="flex">
                            <div class="cart-top-title-big flex">
                                <div class="title-contetn ellipsis">{{ items.DiscountCateName }}</div>
                                <span>订单折扣:</span>
                            </div>
                        </div>
                        <div class="flex">
                            <div class="inputStyle" style="width: 150rpx">
                                <el-input v-model="items.inputValue" type="number" class="el-select-medium mr10" placeholder="填写折扣率" />
                            </div>
                            <el-button type="primary" @click="userComputer1()">计算</el-button>
                        </div>
                    </div>
                    <div>
                        <el-table :data="items.Goods" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                            <el-table-column align="center" width="50px">
                                <template v-slot="scope">
                                    <el-checkbox v-model="scope.row.checked" :checked="scope.row.checked"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Goods_Product_MainBoxNumber" label="主机箱号" align="center" show-overflow-tooltip width="100"></el-table-column>
                            <el-table-column prop="Goods_Product_TypeName" label="销售组" align="center" show-overflow-tooltip width="140"></el-table-column>
                            <el-table-column prop="Goods_Product_Name" label="商品名称" align="left" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="Goods_Product_Spec" label="规格" align="center" show-overflow-tooltip width="160"></el-table-column>
                            <el-table-column prop="Goods_Product_Price" label="单价" align="center" width="100">
                                <template v-slot="scope">
                                    <div>￥{{ scope.row.Goods_Product_Price.toFixed(2) }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Goods_Product_DefaultDiscountPrice" label="默认折扣价" align="center" show-overflow-tooltip width="120">
                                <template v-slot="scope">
                                    <div class="moneyRed">￥{{ scope.row.Goods_Product_DefaultDiscountPrice }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Goods_Amount" label="数量" align="center" width="100"></el-table-column>
                            <el-table-column prop="Goods_IsInsale" label="调整折扣价" align="center" width="140">
                                <template v-slot="scope">
                                    <el-input v-model="scope.row.Goods_Product_AdjustDiscountPrice" type="number" @blur="userComputer1()"></el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Goods_TotalPrice" label="合计" align="center" width="140"></el-table-column>
                        </el-table>
                    </div>
                    <div class="total">
                        商品金额合计:
                        <span>￥{{ items.Porduct_Pirce || 0 }}</span>
                        订单金额:
                        <span>￥{{ items.Orders_Price || 0 }}</span>
                        折扣率:{{ Number(((items.Orders_Price / items.Porduct_Pirce) * 100).toFixed(2)) }}%
                        <span>{{ Number((items.Orders_Price / items.Porduct_Pirce) * 10).toFixed(3) | formatePrice3 }}折</span>
                    </div>
                </div>
            </div>
            <div class="cart-list-container mt20" v-if="activityCartList && activityCartList.length > 0">
                <div class="form-title" style="margin-top: 0">
                    <svg-icon icon-class="lm" class-name="lm-icon" />
                    促销商品
                </div>
                <div class="cart-list" v-for="items in activityCartList" :key="items.ID">
                    <div class="cart-top flex">
                        <div class="flex">
                            <div class="cart-top-title flex">
                                <div class="title-contetn ellipsis">{{ items.DiscountCateName }}</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <el-table :data="items.Goods" style="width: 100%" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                            <el-table-column align="center" width="50px">
                                <template v-slot="scope">
                                    <el-checkbox v-model="scope.row.checked" :checked="scope.row.checked"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Goods_Product_MainBoxNumber" label="主机箱号" align="center" show-overflow-tooltip width="100"></el-table-column>
                            <el-table-column prop="Goods_Product_TypeName" label="销售组" align="center" show-overflow-tooltip width="140"></el-table-column>
                            <el-table-column prop="Goods_Product_Name" label="商品名称" align="left" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="Goods_Product_Spec" label="规格" align="center" show-overflow-tooltip width="160"></el-table-column>
                            <el-table-column prop="Goods_Product_Price" label="单价" align="center" width="100"></el-table-column>
                            <el-table-column prop="Goods_Product_DefaultDiscountPrice" label="默认折扣价" align="center" show-overflow-tooltip width="120">
                                <template v-slot="scope">
                                    <div class="moneyRed">￥{{ scope.row.Goods_Product_DefaultDiscountPrice }}</div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Goods_Amount" label="数量" align="center" width="100"></el-table-column>
                            <el-table-column prop="Goods_IsInsale" label="调整折扣价" align="center" width="140">
                                <template v-slot="scope">
                                    <el-input v-if="scope.row.NoEditPrice != 1" v-model="scope.row.Goods_Product_AdjustDiscountPrice" type="number" @blur="userComputer1()"></el-input>
                                    <div v-else>
                                        {{ scope.row.Goods_Product_AdjustDiscountPrice }}
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Goods_TotalPrice" label="合计" align="center" width="150"></el-table-column>
                        </el-table>
                    </div>
                    <div class="total">
                        商品金额合计:
                        <span>￥{{ items.Porduct_Pirce || 0 }}</span>
                        订单金额:
                        <span>￥{{ items.Orders_Price || 0 }}</span>
                        折扣率:{{ Number(((items.Orders_Price / items.Porduct_Pirce) * 100).toFixed(2)) }}%
                        <span>{{ Number((items.Orders_Price / items.Porduct_Pirce) * 10).toFixed(3) | formatePrice3 }}折</span>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
    name: 'submitSpcOrder',
    props: {
        Customer_info: {
            type: Object,
            default: () => ({})
        },
        submitpaymentObj: {
            type: Object,
            default: () => ({})
        },
        // 商机信息
        PipelineCustomer: {
            type: Object,
            default: () => ({})
        },
        //订单类型: 0销售订单1服务订单
        Orders_Type: {
            type: Number,
            default: 0
        },
        //交易类型:0：正常交易 1报价单2打包订单
        TradeType: {
            type: Number,
            default: 0
        },
        //合同来源: 0报价单1合同变更2独立合同
        Orders_SourceCate: {
            type: Number,
            default: 2
        },
        cartList: {
            type: Array,
            default: () => []
        },
        activityCartList: {
            type: Array,
            default: () => []
        },
        // 1正式报价单 0临时
        SPCApply_BillType: {
            type: Number,
            default: 1
        },
        // 报价单ID，用于标识是否为修改模式
        applyId: {
            type: [String, Number],
            default: ''
        }
    },
    async mounted() {
        let orderRequests = [this.getProjectTypes({ name: 'one', id: 0 }), this.GetOfficeMemberOption(), this.GetBranchOfficeByToken()];
        await Promise.all(orderRequests);
        this.$emit('mountedEnd');
    },
    computed: {
        ...mapState({
            countryList: (state) => state.common.countryList,
            provinceList: (state) => state.common.provinceList,
            cityList: (state) => state.common.cityList,
            districtList: (state) => state.common.districtList
        })
    },
    data() {
        return {
            params: {
                Customer_Project_Country: '1', // 项目国家
                Customer_Project_State: '', // 省
                Customer_Project_City: '', // 市
                Customer_Project_County: '', // 区
                Orders_ProjectType_ID: '', // 项目类型
                Orders_ProjectType_ID_Two: '', // 项目类型二
                Orders_ProjectType_ID_Three: '', // 项目类型三
                Customer_Project_NameThree: '', // 工程名称前缀
                Customer_Project_Name: '', // 工程名称
                Customer_Project_NameTwo: '', // 工程名称后缀
                Orders_OfficeManID: '', // 业务员
                Orders_OfficeManName: '', // 业务员名称
                SPCApply_PlanDeliveryDays: '', // 预计供货时间
                officeInfoDetail: '' // 办事处信息
            },

            cityListopt: [],
            districtListopt: [],

            ProjectTypesList: [],
            ProjectTypesListTwo: [],
            ProjectTypesListThree: [],

            officeManID: '',
            offinceList: [],

            SupplierList: [],

            officeInfo: '',
            // 商品清单参数
            Goods_ListJson: {
                Customer_Project_Country: '1',
                Customer_Project_State: '', //省
                Customer_Project_City: '', //市
                Customer_Project_County: '', //区
                SPCApply_ID: 0 //添加默认为0
            },
            pickerOptions: {
                disabledDate(time) {
                    // 禁用今天之前的日期
                    return time.getTime() < Date.now() - 8.64e7; // 8.64e7 是一天的毫秒数
                }
            }
        };
    },
    methods: {
        // 获取报价单详情
        async getApplyOrdersDetails(e) {
            let result = e.detailsData;
            console.log('报价单详情', result);
            this.disposeDetails(result);
        },
        // 地址验证方法
        validateAddressValue(value, optionsList, codeField = 'Code') {
            if (!value || !optionsList || !Array.isArray(optionsList)) {
                return false;
            }
            return optionsList.some((item) => item[codeField] == value);
        },
        // 一键转正式-处理详情信息回显
        disposeDetails(detailsData) {
            // 需要根据省筛选出市列表，根据市筛选出县列表，这样才能回显
            this.cityListopt = this.cityList.filter((item) => item.Statecode == detailsData.SPCApply_ProjectState);
            this.districtListopt = this.districtList.filter((item) => item.citycode == detailsData.SPCApply_ProjectCity);
            // 回显项目类型
            this.DisplayProjectTypeRecursion(detailsData.SPCApply_ProjectType_ID);
            // 项目名称
            this.params.Customer_Project_Name = detailsData.SPCApply_ProjectName;
            // 映射关系

            const mapping = {
                Customer_Project_Country: 'SPCApply_ProjectCountry',
                Customer_Project_State: 'SPCApply_ProjectState',
                Customer_Project_City: 'SPCApply_ProjectCity',
                Customer_Project_County: 'SPCApply_ProjectCounty',
                Orders_OfficeManID: 'SPCApply_OfficeManID',
                SPCApply_PlanDeliveryDays: 'SPCApply_PlanDeliveryDays'
            };
            // 赋值操作
            for (const key in mapping) {
                if (mapping.hasOwnProperty(key)) {
                    this.params[key] = detailsData[mapping[key]];
                }
            }
            if (new Date(this.params.SPCApply_PlanDeliveryDays).getTime() <= new Date('1900-01-01T00:00:00').getTime()) {
                this.params.SPCApply_PlanDeliveryDays = '';
            }
            if (this.params.Orders_OfficeManID) {
                const officeItem = this.offinceList.find((item) => item.ID == this.params.Orders_OfficeManID);
                this.params.Orders_OfficeManName = officeItem ? officeItem.OwnerName : detailsData.SPCApply_OfficeManName || '';
            } else {
                this.params.Orders_OfficeManName = detailsData.SPCApply_OfficeManName || '';
            }
        },

        // 项目类型联动展示
        async DisplayProjectTypeRecursion(e) {
            let result;
            result = await this.$newsApi.order.DisplayProjectTypeRecursionID({ ID: e });
            // 工程类型
            result.data = result.data.data;
            if (result.data) {
                var typeArr = result.data.split('>');
                await this.getProjectTypes({ name: 'two', id: typeArr[0] });
                this.params.Orders_ProjectType_ID = Number(typeArr[0]) || '';
                if (typeArr.length < 2) return;
                this.params.Orders_ProjectType_ID_Two = Number(typeArr[1]) || '';
                if (!typeArr[1]) return;
                await this.getProjectTypes({ name: 'three', id: typeArr[1] });
                this.params.Orders_ProjectType_ID_Three = Number(typeArr[2]) || '';
            }
        },
        // 获取表单参数
        getFormParams() {
            let data = this.params;
            return data;
        },
        // 获取地址和项目类型名称
        getNameMethods() {
            let data = this.params;
            let nameInfo = {};
            nameInfo.Customer_Project_Site_Name = this.getAddressName(data.Customer_Project_Country, data.Customer_Project_State, data.Customer_Project_City, data.Customer_Project_County);
            nameInfo.Orders_ProjectType_Name = this.getProjectTypeName(data.Orders_ProjectType_ID, data.Orders_ProjectType_ID_Two, data.Orders_ProjectType_ID_Three);
            // nameInfo.Orders_Address_Site_Name = this.getAddressName(data.Orders_Address_Country, data.Orders_Address_State, data.Orders_Address_City, data.Orders_Address_County)
            return nameInfo;
        },
        // 根据工程地址code获取地址名称
        getAddressName(country, state, city, county) {
            let stateItem = this.provinceList.find((item) => item.Code == state);
            let cityItem = this.cityList.find((item) => item.Code == city);
            let countyItem = this.districtList.find((item) => item.Code == county);
            
            let Customer_Project_State_Name = stateItem ? stateItem.Name || '' : '';
            let Customer_Project_City_Name = cityItem ? cityItem.Name || '' : '';
            let Customer_Project_County_Name = countyItem ? countyItem.Name || '' : '';
            let Customer_Project_Site_Name = Customer_Project_State_Name + ' ' + Customer_Project_City_Name + ' ' + Customer_Project_County_Name;
            return Customer_Project_Site_Name;
        },
        // 根据项目类型获取项目类型名称
        getProjectTypeName(id, idTwo, idThree) {
            // 防御性检查：确保数组已加载且不为空
            let Orders_ProjectType_Name = '';
            let Orders_ProjectType_Name_Two = '';
            let Orders_ProjectType_Name_Three = '';
            
            // 一级分类
            if (id && this.ProjectTypesList && this.ProjectTypesList.length > 0) {
                const item = this.ProjectTypesList.find((item) => item.Project_Type_ID == id);
                Orders_ProjectType_Name = item ? item.Project_Type_Name || '' : '';
            }
            
            // 二级分类
            if (idTwo && this.ProjectTypesListTwo && this.ProjectTypesListTwo.length > 0) {
                const item = this.ProjectTypesListTwo.find((item) => item.Project_Type_ID == idTwo);
                Orders_ProjectType_Name_Two = item ? item.Project_Type_Name || '' : '';
            }
            
            // 三级分类
            if (idThree && this.ProjectTypesListThree && this.ProjectTypesListThree.length > 0) {
                const item = this.ProjectTypesListThree.find((item) => item.Project_Type_ID == idThree);
                Orders_ProjectType_Name_Three = item ? item.Project_Type_Name || '' : '';
            }
            
            let Orders_ProjectType_info = Orders_ProjectType_Name + Orders_ProjectType_Name_Two + Orders_ProjectType_Name_Three;
            return Orders_ProjectType_info;
        },
        /*
        选择省
        */
        provinceChange(e) {
            console.log(e, 'eeeee');
            this.cityListopt = [];
            this.params.Customer_Project_City = '';
            this.districtListopt = [];
            this.params.Customer_Project_County = '';
            this.cityListopt = this.cityList.filter((item) => item.Statecode == e);
        },
        /*
        选择市
        */
        cityChange(e) {
            console.log(e, 'eeeee');
            this.districtListopt = [];
            this.params.Customer_Project_County = '';
            this.districtListopt = this.districtList.filter((item) => item.citycode == e);
        },
        // 获取项目类型
        async getProjectTypes(e) {
            var result = await this.$newsApi.order.getProjectTypes({
                CateID: e.id
            });
            if (e.name == 'one') {
                this.ProjectTypesList = result.data.data || [];
            } else if (e.name == 'two') {
                this.ProjectTypesListTwo = result.data.data || [];
                if (this.ProjectTypesListTwo.length == 0) {
                    this.params.Orders_ProjectType_ID_Two = '';
                }
            } else if (e.name == 'three') {
                this.ProjectTypesListThree = result.data.data || [];
                if (this.ProjectTypesListThree.length == 0) {
                    this.params.Orders_ProjectType_ID_Three = '';
                }
            }
        },
        // 公共select选择
        publicSelectChange(e, details) {
            if (e == 'office') {
                this.params.Orders_OfficeManName = this.offinceList.find((item) => item.ID == details).OwnerName;
            } else if (e == 'cabinet') {
                this.params.CabinetSupplierName = this.SupplierList.find((item) => item.value == details).Name;
                console.log('this.params.CabinetSupplierName', this.params.CabinetSupplierName);
            }
        },
        // 报价单业务员选择
        async GetOfficeMemberOption() {
            var result = await this.$newsApi.order.getOfficeMemberOption({ UserID: this.officeManID || this.$store.state.user.userId });
            for (let i = 0; i < result.data.data.length; i++) {
                result.data.data[i].OwnerName = '[' + result.data.data[i].UserCode + ']' + result.data.data[i].OwnerName;
            }
            this.offinceList = result.data.data;
            // 回显当前选择的业务员
            // console.log(result.data);
            if (!this.params.Orders_OfficeManID) {
                for (let i = 0; i < result.data.data.length; i++) {
                    if (result.data.data[i].IsCheck == 'True') {
                        this.params.Orders_OfficeManID = result.data.data[i].ID;
                        this.params.Orders_OfficeManName = result.data.data[i].OwnerName;
                        break;
                    }
                }
            } else {
                const officeItem = this.offinceList.find((item) => item.ID == this.params.Orders_OfficeManID);
                this.params.Orders_OfficeManName = officeItem ? officeItem.OwnerName : this.params.Orders_OfficeManName;
            }
        },
        // 计算折扣 销售合同
        userComputer1() {
            var obj = {};
            var list = this.cartList.concat(this.activityCartList);
            for (let i = 0; i < list.length; i++) {
                // discountrate_只传默认商品的
                if (i < this.cartList.length) {
                    obj['discountrate_' + list[i].DiscountCateID] = list[i].inputValue; //订单折扣
                }
                var cartId = [];
                for (let j = 0; j < list[i].Goods.length; j++) {
                    if (list[i].Goods[j].checked) {
                        cartId.push(list[i].Goods[j].Goods_ID);
                    }
                    if (i < this.cartList.length) {
                        obj['discountgoods_' + list[i].DiscountCateID] = cartId.join(); //选中的商品
                    }
                    obj['discountprice_' + list[i].Goods[j].Goods_ID] = list[i].Goods[j].Goods_Product_AdjustDiscountPrice; //选中的商品
                }
            }
            this.Goods_ListJson.Customer_Project_State = this.params.Customer_Project_State;
            this.Goods_ListJson.Customer_Project_City = this.params.Customer_Project_City;
            this.Goods_ListJson.Customer_Project_County = this.params.Customer_Project_County;
            var needObj = JSON.parse(JSON.stringify(this.Goods_ListJson));
            for (var key in obj) {
                needObj[key] = obj[key];
            }
            this.$emit('userComputer', needObj);
        },
        // 根据办事处用户查询所属办事处信息
        async GetBranchOfficeByToken() {
            var result = await this.$newsApi.order.GetBranchOfficeByToken();
            if (result.data.Resultcode == 0) {
                this.officeInfo = result.data.data;
                this.GetBranchOfficeParentDepartment();
            }
        },
        // 根据办事处用户查询所属办事处信息
        async GetBranchOfficeParentDepartment() {
            var result = await this.$newsApi.order.GetBranchOfficeParentDepartment({ Code: this.officeInfo.Number });
            if (result.data.Resultcode == 0) {
                this.params.officeInfoDetail = result.data.data + '-' + this.officeInfo.Name;
            }
        },
        countryChange(i) {
            this.params.Customer_Project_Country = i;
            this.params.Customer_Project_State = '';
            this.params.Customer_Project_City = '';
            this.params.Customer_Project_County = '';
            this.districtListopt = [];
            this.cityListopt = [];
        },
        // 默认工程信息
        async GetBranchOfficeByID() {
            let ress = await this.$newsApi.order.GetBranchOfficeByID({});
            let res = ress.data.data;
            
            // 如果是修改模式且已有区域信息，则不覆盖
            const isEditMode = this.applyId && this.applyId !== '' && this.applyId !== 0;
            const hasExistingAreaInfo = this.params.Customer_Project_State || 
                                      this.params.Customer_Project_City || 
                                      this.params.Customer_Project_County;
            
            if (isEditMode && hasExistingAreaInfo) {
                // 修改模式下有已存在的区域信息，只更新选项列表，不覆盖已有值
                this.cityListopt = this.cityList.filter((item) => item.Statecode == this.params.Customer_Project_State);
                this.districtListopt = this.districtList.filter((item) => item.citycode == this.params.Customer_Project_City);
            } else {
                // 新建模式或没有已存在的区域信息，使用默认值
                this.cityListopt = this.cityList.filter((item) => item.Statecode == res.State);
                this.districtListopt = this.districtList.filter((item) => item.citycode == res.City);
                this.params.Customer_Project_Country = res.Country;
                this.params.Customer_Project_State = res.State;
                this.params.Customer_Project_City = res.City;
                this.params.Customer_Project_County = res.County;
            }

            if (this.PipelineCustomer && this.PipelineCustomer.ID > 0) {
                this.params.Customer_Project_Country = "1";
                this.params.Orders_ProjectAddress = this.PipelineCustomer.address;

                this.params.Customer_Project_State = '';
                this.params.Customer_Project_City = '';
                this.params.Customer_Project_County = '';
                this.cityListopt = [];
                this.districtListopt = [];

                let countyinfo = await this.$newsApi.order.getSysCountyCode({
                    statecode: this.PipelineCustomer.province,
                    countryCode: this.PipelineCustomer.area,
                    citycode: this.PipelineCustomer.city
                });

                const countyCode = countyinfo && countyinfo.data && countyinfo.data.data;
                countyinfo = this.districtList.find((item) => item.Code == countyCode);
                if (countyinfo && countyinfo.Code) {
                    this.params.Customer_Project_County = countyinfo.Code;
                    this.params.Customer_Project_City = countyinfo.citycode;
                }
                if (countyinfo && countyinfo.citycode) {
                    let cityinfo = this.cityList.find((item) => item.Code == countyinfo.citycode);
                    if (cityinfo) {
                        this.params.Customer_Project_State = cityinfo.Statecode;

                    }
                }

                this.cityListopt = this.params.Customer_Project_State ? this.cityList.filter((item) => item.Statecode == this.params.Customer_Project_State) : [];
                this.districtListopt = this.params.Customer_Project_City ? this.districtList.filter((item) => item.citycode == this.params.Customer_Project_City) : [];
            }


            if (!this.validateAddressValue(this.params.Customer_Project_State, this.provinceList)) {
                this.params.Customer_Project_State = '';
            }
            if (!this.validateAddressValue(this.params.Customer_Project_City, this.cityListopt)) {
                this.params.Customer_Project_City = '';
            }
            if (!this.validateAddressValue(this.params.Customer_Project_County, this.districtListopt)) {
                this.params.Customer_Project_County = '';
            }
        },
        // 商机展示工程信息,期望交货时间
        async currentDataPipelineList(e) {
            this.params.Customer_Project_Name = e.projectName;
            if (e.demandDate) {
                this.params.SPCApply_PlanDeliveryDays = e.demandDate;
                if (Number(e.demandDate.substring(0, e.demandDate.indexOf('-')) <= 1900)) {
                    this.params.SPCApply_PlanDeliveryDays = '';
                }
            }
            let res = await this.$newsApi.order.DisplayProjectTypeByNameRecursionID({ Project_Name: e.industry2 });
            // 工程类型
            let result = res.data;
            if (result.data) {
                var typeArr = result.data.split('>');
                this.params.Orders_ProjectType_ID = +typeArr[0] || '';
                await this.getProjectTypes({ name: 'two', id: typeArr[0] });
                if (typeArr.length < 2) return;
                this.params.Orders_ProjectType_ID_Two = +typeArr[1] || '';
                if (!typeArr[1]) return;
                await this.getProjectTypes({ name: 'three', id: typeArr[1] });
                this.params.Orders_ProjectType_ID_Three = +typeArr[2] || '';
            }
        }
    }
};
</script>

<style scoped lang="scss">
/deep/ .lm-icon {
    margin-right: 10px;
}
.mt0 {
    margin-top: 0 !important;
}

.mt10 {
    margin-top: 10px;
}

.ml10 {
    margin-left: 10px;
}
.mr10 {
    margin-right: 10px;
}
.mb10 {
    margin-bottom: 10px;
}
.tip {
    font-size: 12px;
    color: #999999;
    margin-left: 10px;
}

.form-title {
    margin: 40px 0 20px 0;
    font-size: 16px;
    font-weight: 700;
}
.flex {
    display: flex;
    align-items: center;
}
.info {
    // width: 600px;

    .info-title {
        font-size: 16px;
        font-weight: 700;
    }

    .info-item {
        display: flex;
        margin: 10px 0;
        font-size: 14px;
        color: #000000;

        .label {
            width: 90px;
        }

        .content {
            flex: 1;
            height: auto;
        }
    }

    .label-middle {
        width: 100px;
    }
}
.cart-list-container {
    border: 1px solid #e4e7ed;
    border-radius: 15px;
    padding: 20px 25px 10px 25px;
}
.cart-list {
    background-color: #ffffff;
    font-size: 14px;
    .cart-top {
        font-weight: 700;
        margin-bottom: 10px;
        .cart-top-title {
            .title-contetn {
                font-size: 14px;
                margin-right: 10px;
            }
        }
        .cart-top-title-big {
            .title-contetn {
                font-size: 14px;
                font-weight: bold;
                margin-right: 10px;
            }
        }
    }
    .cart-top-title-big {
        font-size: 14px;
        font-weight: normal;
        margin-bottom: 10px;
    }
}
.total {
    font-size: 14px;
    text-align: right;
    margin-top: 10px;
    span {
        color: red;
        padding-right: 20px;
    }
}
</style>
